interface Props {
  color?: string
  width?: number
  height?: number
}

export const CircleIcon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="10.5" cy="10.5" r="10" stroke={color} />
    </svg>
  )
}
